<template>
  <div>
    <div id="app" v-if="redeemCodes && redeemCodes.length != 0">
      <div class="appHeader">
        <div class="header">
          <img class="close-img" :src="closeImage" alt="" @click="goBack" />
          {{ $t("MyRedemption.title") }}
        </div>
      </div>

      <div style="margin-top: 44px">
        <div
          class="result-content"
          v-for="(item, index) in redeemCodes"
          :key="index"
        >
          <div class="qr-container">
            <div>
              <div class="result-content-title">
                {{ $t("MyRedemption.code") }}
              </div>
              <canvas
                :ref="(el) => setItemRef(el, index)"
                :style="{ width: size + 'px', height: size + 'px' }"
              ></canvas>
              <div class="result-text">
                {{ item }}
                <span class="copy" @click="handleCopy(item)">{{
                  $t("MyRedemption.copy")
                }}</span>
              </div>
              <div class="line1"></div>
              <div class="tip">
                <div
                  style="padding-bottom: 8px"
                  v-if="productName == '离线翻译'"
                >
                  {{ $t("MyRedemption.tip1") }}
                </div>
                <div style="padding-bottom: 8px" v-if="$route.query.id == 2">
                  {{ $t("MyRedemption.tip2") }}
                </div>
                <div
                  style="padding-bottom: 8px"
                  v-if="baseList.includes(productName)"
                >
                  {{ $t("MyRedemption.tip3") }}
                </div>
                <div>{{ $t("MyRedemption.time") }}{{ purchaseTime }}</div>
              </div>
              <div>
                <el-button
                  type="primary"
                  class="save-button"
                  @click="saveQRCode(index)"
                  >{{ $t("MyRedemption.save") }}</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="message" v-if="show">
        <div class="tip1">{{ $t("MyRedemption.success") }}</div>
      </div>
    </div>
    <div v-else style="height: 100vh">
      <div class="header">
        <img class="close-img" :src="closeImage" alt="" @click="goBack" />
        {{ $t("MyRedemption.title") }}
      </div>
      <div
        style="
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
        v-if="show1"
      >
        {{ $t("OffLineResult.stock") }}
      </div>
    </div>
  </div>
</template>
    
    <script>
// import moment from 'moment';
import QRCode from "qrcode"; // 引入库
import {
  getTransactionRedeemCodes,
  getTransactionOrders,
} from "@/api/login/user";
export default {
  name: "MyRedemption",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      purchaseTime: "",
      baseList: ["基础服务（一个月）", "基础服务（半年）", "基础服务（年）"],
      productID: "",
      productName: "",
      dataList: [
        "1111",
        "2222",
        "333",
        "444",
        "555",
        "666",
        "777",
        "888",
        "999",
        "000",
        "00111",
      ],
      itemRefs: {}, // 存储所有 ref 的对象
      size: 150,
      url: "https://www.bilibili.com/",
      bgColor: "#ffffff",
      color: "#000",
      content: "generateQRCode",
      redeemCodes: [],
      name: "此码仅用于兑换离线翻译功能",
      show: false,
      message: "",
      RedemptionCode: "YUJH7273889",
      closeImage: require("@/assets/close.png"),
      successImage: require("@/assets/success.png"),
      QRCodeImg: require("@/assets/QRCode.png"),
      intervalId: null, // 用于保存定时器 ID
      show1: false,
    };
  },
  watch: {},
  async mounted() {
    this.show1 = true;
    if (this.$route?.query?.name) {
      this.name = this.$route.query.name;
    }
    const list = JSON.parse(localStorage.getItem("MyRedemption"));

    if (list?.metadata?.batch_no) {
      this.productID = list?.productID;
      this.productName = list?.productName;
      this.purchaseTime = list?.purchaseTime;
      // console.log("list?.purchaseTime",moment(list?.purchaseTime).add(8,'hours').format('YYYY-MM-DD HH:mm:ss'));
      await getTransactionRedeemCodes({
        batchNo: list?.metadata?.batch_no,
      }).then((res) => {
        if (res?.data) {
          res.data.forEach((item) => {
            this.redeemCodes.push(item.code);
            this.show2 = true;
            this.show1 = false;
          });
          if (list?.metadata?.batch_no && this.redeemCodes.length != 0) {
            if (this.intervalId) {
              clearInterval(this.intervalId);
            }
          }
        }
      });
    } else {
      this.intervalId = setInterval(this.getTransactionOrdersNet, 5000);
    }
    setTimeout(() => {
      if (this.redeemCodes && this.redeemCodes.length != 0) {
        this.redeemCodes.forEach((item, index) => {
          const canvas = this.itemRefs[index];
          QRCode.toCanvas(canvas, item, {
            width: this.size,
            color: {
              dark: this.color, // 深色模块颜色
              light: this.bgColor, // 浅色模块颜色
            },
            errorCorrectionLevel: "H", // 容错等级 (L/M/Q/H)
          });
        });
      }
    }, 1000);
  },
  beforeDestroy() {
    // 组件销毁前清理定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    getTransactionOrdersNet() {
      const list = JSON.parse(localStorage.getItem("MyRedemption"));
      this.productID = list?.productID;
      this.productName = list?.productName;
      this.purchaseTime = list?.purchaseTime;
      const params = {
        productType: "",
        orderID: list.orderID,
        page: 1,
        limit: 10,
        expandOrderType:"exchange"
      };
      getTransactionOrders(params).then(async (res) => {
        if (res?.data) {
          console.log("res.data.metadata", res.data[0].metadata);
          if (res.data[0].metadata?.batch_no) {
            await getTransactionRedeemCodes({
              batchNo: res.data[0].metadata?.batch_no,
            }).then((res) => {
              if (res?.data) {
                res.data.forEach((item) => {
                  this.redeemCodes.push(item.code);
                  this.show2 = true;
                  this.show1 = false;
                  setTimeout(() => {
                    if (this.redeemCodes && this.redeemCodes.length != 0) {
                      this.redeemCodes.forEach((item, index) => {
                        const canvas = this.itemRefs[index];
                        QRCode.toCanvas(canvas, item, {
                          width: this.size,
                          color: {
                            dark: this.color, // 深色模块颜色
                            light: this.bgColor, // 浅色模块颜色
                          },
                          errorCorrectionLevel: "H", // 容错等级 (L/M/Q/H)
                        });
                      });
                    }
                  }, 1000);
                });
                if (this.redeemCodes.length != 0) {
                  if (this.intervalId) {
                    clearInterval(this.intervalId);
                  }
                }
              }
            });
          }
        }
      });
    },
    saveQRCode(index) {
      const canvas = this.itemRefs[index];
      if (!canvas) {
        return;
      }
      const base64Text = canvas.toDataURL("image/png");
      const blob = this.getBlob(base64Text);
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, "qrcode.png");
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "qrcode.png";
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }, 100);
      }
    },
    getBlob(base64) {
      const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
      const byteString = atob(base64.split(",")[1]);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const intArray = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([intArray], { type: mimeString });
    },
    setItemRef(el, index) {
      if (el) {
        // 将引用按索引存储到对象中
        this.itemRefs[index] = el;
      }
    },
    getName(val) {
      const list = {
        离线翻译: "此码仅用于兑换离线翻译功能",
        "音/视频通话": "此码仅用于兑换音/视频通话翻译功能",
        基础服务: "此码仅用于兑换基础服务续费功能",
      };
      return list[val];
    },
    goBack() {
      this.$router.push({
        path: "/RedemptionList",
      });
    },
    handleCopy(val) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(val)
          .then(() => {
            this.show = true;
            this.message = this.$t("OffLineResult.copySuccess");
            setTimeout(() => {
              this.show = false;
            }, 1000);
          })
          .catch((err) => {
            this.show = true;
            this.message = err;
            setTimeout(() => {
              this.show = false;
            }, 1000);
            console.error("Failed to copy text: ", err);
          });
        return;
      }

      if (document.execCommand) {
        console.log("document.execCommand---copy");
        
        const textArea = document.createElement("textarea");
        textArea.setAttribute("readonly", "readonly");
        textArea.value = val;
        document.body.appendChild(textArea);
        textArea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);

        if (successful) {
          this.show = true;
          this.message = this.$t("OffLineResult.copySuccess");
          setTimeout(() => {
            this.show = false;
          }, 1000);
        } else {
          this.show = true;
          this.message = "copy failed";
          setTimeout(() => {
            this.show = false;
          }, 1000);
        }
      }else{
        console.log('Failed to copy---document.execCommand---not');
      }
    },
  },
};
</script>
    
    <style scoped>
#app {
  height: 100vh;
  text-align: left;
  background: #f5f5f5;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px 16px;
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.result-title {
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  text-align: center;
  margin: 40px 0px 16px 0px;
}
.success-img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 16px;
}
.result-tip {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  text-align: center;
  margin-bottom: 32px;
}
.result-content {
  width: 100%;
  /* height: 385px; */
  border-radius: 16px;
  background: #ffffff;
  text-align: center;
  margin-top: 24px;
  padding-bottom: 24px;
}
.result-content-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  color: #3d3d3d;
  padding-top: 16px;
}
.QRCodeImg {
  width: 125px;
  height: 125px;
}
.result-text {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  margin-bottom: 16px;
}
.copy {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 品牌色 */
  color: #f65e3d;
  cursor: pointer;
}
.line1 {
  width: 90%;
  height: 0px;
  border-top: 1px dashed #d8d8d8;
  text-align: center;
  margin: 0 auto;
}
.tip {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  text-align: left;
  padding: 16px;
}
.save-button {
  width: calc(100% - 32px);
  height: 44px;
  border-radius: 8px;
}
.message {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  line-height: 60px;
}
.tip1 {
  min-width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  opacity: 1;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
  padding: 0px 20px;
}
.appHeader {
  position: fixed;
  top: 0px;
  left: 0px;
  width: calc(100% - 32px);
  background-color: #f5f5f5;
  padding: 0px 16px;
}
</style>
    